import Icon from './Icon.tsx';
import url from '@assets/images/check-selected.svg';

const CheckSelectedIcon = () => {
  return <Icon icon={url} />;
};

export default CheckSelectedIcon;
